import CompanyDetails from "@features/clinics/pages/settings/components/CompanyDetails";
import SettingsLocations from "@features/clinics/pages/settings/components/SettingsLocations";
import SettingsSubsription from "@features/clinics/pages/settings/components/SettingsSubscription/SettingsSubsription";
import MembersAndPermissions from "@features/clinics/pages/settings/components/MembersAndPermissions";
import SettingsInvoices from "@features/clinics/pages/settings/components/SettingsInvoices";
import SettingsIntegrations from "@features/clinics/pages/settings/components/SettingsIntegrations/SettingsIntegrationsPage";
import EditMemberWrapper from "@features/clinics/pages/settings/components/EditMemberWrapper";
import EditInviteWrapper from "@features/clinics/pages/settings/components/EditInviteWrapper";
import CompliancePage from "@features/clinics/pages/settings/components/SettingsCompliance/CompliancePage";
import { AppModeSelector } from "@shared/ui";
import { ProtectedRoute } from "@shared/ui";
import { CLINIC_ROUTES, ROOTS, SETTINGS_ROUTES } from "@app/config/constants";
import { Outlet, Route } from "react-router-dom";

export default function getClinicSettingsRoutes() {
  return (
    <Route
      path={`${ROOTS.CLINIC}/:clinicId/${CLINIC_ROUTES.SETTINGS}`}
      element={
        <ProtectedRoute>
          <Outlet />
        </ProtectedRoute>
      }
    >
      <Route path={SETTINGS_ROUTES.DETAILS} element={<CompanyDetails />} />
      <Route path={SETTINGS_ROUTES.LOCATIONS} element={<SettingsLocations />} />
      <Route
        path={SETTINGS_ROUTES.SUBSCRIPTION_PLAN}
        element={<SettingsSubsription />}
      />
      <Route
        path={`${SETTINGS_ROUTES.MEMBERS_PERMISSIONS}/members/:memberId`}
        element={<EditMemberWrapper />}
      />
      <Route
        path={`${SETTINGS_ROUTES.MEMBERS_PERMISSIONS}/invites/:inviteId`}
        element={<EditInviteWrapper />}
      />
      <Route
        path={SETTINGS_ROUTES.MEMBERS_PERMISSIONS}
        element={<MembersAndPermissions />}
      />
      <Route path={SETTINGS_ROUTES.COMPLIANCE} element={<CompliancePage />} />
      <Route path={SETTINGS_ROUTES.INVOICES} element={<SettingsInvoices />} />
      <Route
        path={SETTINGS_ROUTES.INTEGRATIONS}
        element={<SettingsIntegrations />}
      />
      <Route path="*" element={<AppModeSelector />} />
    </Route>
  );
}
